export enum Astragal {
  Z = 'Z Astragal',
  FI = 'Flat Astragal Inactive',
  FA = 'Flat Astragal Active',
}
